import { render, staticRenderFns } from "./TextFormStep.vue?vue&type=template&id=d6c29cbc&"
import script from "./TextFormStep.vue?vue&type=script&lang=js&"
export * from "./TextFormStep.vue?vue&type=script&lang=js&"
import style0 from "./TextFormStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports